module.exports = "pegasus_template/assets/blocks/column-13-theme5.png";